import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

export const Container = styled(Card)`
    margin-top: 12px;
    padding: 14px 8px;
    position: relative;

    @media (max-width: 900px) {
        padding: 14px;
    }
`;

export const Content = styled.div`
    @media (min-width: 900px) {
        display: flex;
    }
`;

export const StyledTextField = styled(TextField)`
    margin: 6px 0;

    @media (min-width: 900px) {
        flex: 1;
        margin: 6px;
    }
`;

export const Co2SavingText = styled(Typography)`
    text-align: center;
    margin-top: 4px;
`;

export const RemoveItemButton = styled(Button)`
    @media (max-width: 900px) {
        display: block;
        margin: 0 auto;
        margin-top: 6px;
    }

    @media (min-width: 900px) {
        position: absolute;
        right: 8px;
        bottom: 8px;
    }
`;